const FONT_POPPINS = 'Poppins';
const FONT_INTER = 'Poppins';

const FONT_SIZE_DEFAULT = '1rem';
const FONT_SIZE_MOBILE = '0.8rem';
const FONT_SIZE_PARAGRAPH = '1rem';
const FONT_SIZE_SMALL = '0.75rem';
const FONT_SIDEBAR = '0.875rem';

const DEFAULT_LINE_HEIGHT = 1.25;
const HEADING_LINE_HEIGHT = 1.25;
const PARAGRAPH_LINE_HEIGHT = 1.5;

const MOBILE_LINE_HEIGHT = 1.25;

const BASE_TYPOGRAPHY_HEADING = `
  font-family: ${FONT_INTER};
  font-weight: 700;
`;

const BASE_TYPOGRAPHY_BODY = `
  font-family: ${FONT_INTER};
  line-height: ${DEFAULT_LINE_HEIGHT};
  // line-height: normal;
`;

const MOBILE_TYPOGRAPHY_BODY = `
  font-family: ${FONT_INTER};
  line-height: ${MOBILE_LINE_HEIGHT};
  // line-height: normal;
`;
const typography = {
  sizes: {
    default: FONT_SIZE_DEFAULT,
    paragraph: FONT_SIZE_PARAGRAPH,
    small: FONT_SIZE_SMALL,
    sidebar: FONT_SIDEBAR,
  },
  headingBase: BASE_TYPOGRAPHY_HEADING,
  bodyBase: BASE_TYPOGRAPHY_BODY,

  heading1: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 64px;
    line-height: 76px;
  `,
  heading2: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 36px;
    line-height: 44px;
  `,
  heading3: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 28px;
    line-height: 36px;
  `,
  heading4: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 20px;
    line-height: 28px;
  `,
  heading5: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 16px;
    line-height: 28px;
  `,
  heading6: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 12px;
    line-height: 20px;
  `,
  buttonTextNormal: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 18px;
    line-height: 20px;
  `,
  buttonTextMedium: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 16px;
    line-height: 20px;
  `,
  buttonTextSmall: `
    ${BASE_TYPOGRAPHY_HEADING}
    font-size: 14px;
    line-height: 16px;
  `,
  body1: `
    font-size: 18px;
    line-height: 24px;
  `,
  body2: `
    font-size: 16px;
    line-height: 24px;
  `,
  body3: `
    font-size: 14px;
    line-height: 20px;
  `,
  UIText: `
    ${BASE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_DEFAULT};    
  `,
  MobileUIText: `
    ${MOBILE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_MOBILE};    
  `,
  UITextSmall: `
    ${BASE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_SMALL};
  `,
  paragraph: `
    ${BASE_TYPOGRAPHY_BODY}
    font-size: ${FONT_SIZE_PARAGRAPH};
    line-height: ${PARAGRAPH_LINE_HEIGHT};
  `,
  paragraphCode: `
    font-family: ${FONT_POPPINS};
    font-size: ${FONT_SIZE_DEFAULT};
    // line-height: normal;
  `,

  defaultLineHeight: DEFAULT_LINE_HEIGHT,
  paragraphLineHeight: PARAGRAPH_LINE_HEIGHT,
  mobileParagraphLineHeight: DEFAULT_LINE_HEIGHT,
};

export default typography;
